'use client';
import RenderSections from '@app-sw/Common/RenderSections';
import WrapLayout from '@app-sw/components/Layout/WrapLayout';
import { Box, Skeleton } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import { Suspense } from 'react';
const MainUi = ({ pageData }) => {
  return (
    <Suspense fallback={<Skeleton />}>
      <WrapLayout pageData={pageData}>
        <Box as="section" className="container-article" p="0" bgColor="#f8f8f8">
          {pageData?.body?.map(section => {
            return (
              <RenderSections
                pageData={pageData}
                section={section}
                key={nanoid(4)}
              />
            );
          })}
        </Box>
      </WrapLayout>
    </Suspense>
  );
};

export default MainUi;
